import { useTranslation } from "react-i18next"

import { Compass, Globe } from "@/components/icons"
import { Card, CardContent, CardHeader } from "@/components/ui/card"
import { CourseLayout } from "@/features/training/components/layouts/course-layout"
import { CourseSection } from "@/features/training/components/layouts/course-section"
import { ensureArray } from "@/features/training/utils/ensure-array"

export function InstallationPage() {
  const { t } = useTranslation("", { keyPrefix: "training.introduction.installation" })

  return (
    <CourseLayout>
      <CourseSection>
        <h1>{t("title")}</h1>
        <p>{t("intro")}</p>
      </CourseSection>

      {/* Edge guide */}
      <CourseSection>
        <Card>
          <CardHeader className="flex-row items-center gap-3 pb-3">
            <div className="bg-primary/10 text-primary flex h-10 w-10 shrink-0 items-center justify-center rounded-xl">
              <Globe className="h-5 w-5" />
            </div>
            <h2 className="text-lg font-semibold">Microsoft Edge</h2>
          </CardHeader>
          <CardContent>
            <ol className="space-y-3">
              {ensureArray<{ title: string; description: string }>(
                t("edge_steps", { returnObjects: true })
              ).map((step, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <span className="bg-primary/10 text-primary flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-bold">
                    {idx + 1}
                  </span>
                  <div>
                    <p className="text-sm font-semibold">{step.title}</p>
                    <p className="text-muted-foreground text-sm">{step.description}</p>
                  </div>
                </li>
              ))}
            </ol>
          </CardContent>
        </Card>
      </CourseSection>

      {/* Chrome guide */}
      <CourseSection>
        <Card>
          <CardHeader className="flex-row items-center gap-3 pb-3">
            <div className="bg-primary/10 text-primary flex h-10 w-10 shrink-0 items-center justify-center rounded-xl">
              <Compass className="h-5 w-5" />
            </div>
            <h2 className="text-lg font-semibold">Google Chrome</h2>
          </CardHeader>
          <CardContent>
            <ol className="space-y-3">
              {ensureArray<{ title: string; description: string }>(
                t("chrome_steps", { returnObjects: true })
              ).map((step, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <span className="bg-primary/10 text-primary flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-bold">
                    {idx + 1}
                  </span>
                  <div>
                    <p className="text-sm font-semibold">{step.title}</p>
                    <p className="text-muted-foreground text-sm">{step.description}</p>
                  </div>
                </li>
              ))}
            </ol>
          </CardContent>
        </Card>
      </CourseSection>

      <CourseSection>
        <h2>{t("tips_title")}</h2>
        <ul className="list-inside list-disc space-y-1 text-sm">
          {ensureArray<string>(t("tips", { returnObjects: true })).map((tip, i) => (
            <li key={i}>{tip}</li>
          ))}
        </ul>
      </CourseSection>
    </CourseLayout>
  )
}
